(function () {
  var memory = {};
  var inflight = {};

  function cleanHandle(value) {
    return String(value || '').replace(/^\/+|\/+$/g, '').replace(/^products\//, '').split('?')[0];
  }

  function normalize(value) {
    return String(value || '').toLowerCase().replace(/[\u0591-\u05C7]/g, '').replace(/[\u05F3\u05F4'\"]/g, '').replace(/\s+/g, ' ').trim();
  }

  function fetchProduct(handle) {
    handle = cleanHandle(handle);
    if (!handle) return Promise.reject(new Error('Missing product handle'));
    if (memory[handle]) return Promise.resolve(memory[handle]);
    if (inflight[handle]) return inflight[handle];

    inflight[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (response) {
      if (!response.ok) throw new Error('Product fetch failed');
      return response.json();
    }).then(function (product) {
      memory[handle] = product;
      delete inflight[handle];
      return product;
    }).catch(function (error) {
      delete inflight[handle];
      throw error;
    });
    return inflight[handle];
  }

  function optionNames(product) {
    return (product && product.options || []).map(function (option) {
      return typeof option === 'string' ? option : (option && option.name || '');
    });
  }

  function findSizeIndex(product) {
    var names = optionNames(product);
    for (var i = 0; i < names.length; i += 1) {
      var name = normalize(names[i]);
      if (name.indexOf('\u05de\u05d9\u05d3\u05d4') !== -1 || name.indexOf('size') !== -1 || name.indexOf('\u05d2\u05d5\u05d3\u05dc') !== -1) return i;
    }
    var variants = product && product.variants || [];
    if (variants.length && variants[0].options && variants[0].options.length) {
      var commonSizes = /^(xxxs|xxs|xs|s|m|l|xl|xxl|xxxl|2xl|3xl|4xl|5xl|6xl|[0-9]{2,3}(?:cm)?)$/i;
      for (var pos = 0; pos < variants[0].options.length; pos += 1) {
        var values = variants.map(function (variant) { return variant.options && variant.options[pos]; }).filter(Boolean);
        if (values.some(function (value) { return commonSizes.test(String(value).replace(/\s/g, '')); })) return pos;
      }
    }
    return -1;
  }

  function findSleeveIndex(product) {
    var names = optionNames(product);
    for (var i = 0; i < names.length; i += 1) {
      var name = normalize(names[i]);
      if (name.indexOf('\u05e9\u05e8\u05d5\u05d5\u05dc') !== -1 || name.indexOf('sleeve') !== -1) return i;
    }
    return -1;
  }

  function unique(values) {
    return values.filter(function (value, index, list) { return value && list.indexOf(value) === index; });
  }

  function availableSizes(product) {
    var index = findSizeIndex(product);
    if (index < 0) return [];
    return unique((product.variants || []).filter(function (variant) { return variant.available; }).map(function (variant) {
      return variant.options && variant.options[index];
    }));
  }

  function allSizes(product) {
    var index = findSizeIndex(product);
    if (index < 0) return [];
    return unique((product.variants || []).map(function (variant) { return variant.options && variant.options[index]; }));
  }

  function variantForSize(product, size, requireAvailable) {
    var index = findSizeIndex(product);
    if (index < 0) return null;
    var wanted = normalize(size);
    return (product.variants || []).find(function (variant) {
      var value = variant.options && variant.options[index];
      return normalize(value) === wanted && (!requireAvailable || variant.available);
    }) || null;
  }

  function variantById(product, id) {
    return (product && product.variants || []).find(function (variant) { return String(variant.id) === String(id); }) || null;
  }

  function sizeForVariant(product, variant) {
    var index = findSizeIndex(product);
    if (index < 0 || !variant || !variant.options) return '';
    return variant.options[index] || '';
  }

  function availabilityForSize(handle, size) {
    return fetchProduct(handle).then(function (product) {
      var variant = variantForSize(product, size, false);
      return { product: product, variant: variant, available: Boolean(variant && variant.available), size: size };
    });
  }

  window.RegistaStock = {
    fetchProduct: fetchProduct,
    findSizeIndex: findSizeIndex,
    findSleeveIndex: findSleeveIndex,
    availableSizes: availableSizes,
    allSizes: allSizes,
    variantForSize: variantForSize,
    variantById: variantById,
    sizeForVariant: sizeForVariant,
    availabilityForSize: availabilityForSize,
    clear: function (handle) { if (handle) delete memory[cleanHandle(handle)]; else memory = {}; }
  };
})();
